import { useMemo } from 'react';

import {
  IEditForm,
  CasEditForm,
  CasRHFTextField,
  CasRHFLexicalRichTextEditor,
  CasRHFSelect,
  CasRHFSwitch,
} from 'src/compass/shared/components';
import { StringsToOptions } from 'src/compass/shared/util/StringsToOptions';

import { RequestTypeSchema } from './RequestTypeSchema';

export default function RequestTypeForm({ row, onSaved }: IEditForm) {
  const { id } = row || {};

  const defaultValues = useMemo(() => (id ? row : {}), [id, row]);

  return (
    <CasEditForm
      defaultValues={defaultValues}
      onSaved={onSaved}
      entity="Uploads/RequestType"
      schema={RequestTypeSchema}
    >
      <CasRHFTextField label="Name" name="name" />
      <CasRHFSelect label="Area" name="area" options={StringsToOptions(['SCE', 'CME'])} />
      <CasRHFTextField label="Subject" name="emailSubjectTemplate" />
      <CasRHFLexicalRichTextEditor label="Body" name="emailBodyTemplate"  mode='simple' />
      <CasRHFSwitch label="From Agent?" name="fromAgent" />
      <CasRHFTextField label='CC' name='cc' />
    </CasEditForm>
  );
}
